import { Outlet } from 'react-router-dom';
import { Box, Container, Paper } from '@mui/material';

export const AuthLayout = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="xs" sx={{ width: { xs: '88%', sm: '100%' }, py: { xs: 3, sm: 0 } }}>
        <Paper elevation={3} sx={{ px: { xs: 2, sm: 4 }, pt: { xs: 3, sm: 4 }, pb: { xs: 3, sm: 5 } }}>
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
};
